import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";


export const makeAssType_18 = ({ book, user }) => ({
    2: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title1: "Buy the Paperback on Amazon",
            description1: "Use the link below to purchase the book. Then click the 'Next Step' button.",

            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post review & Upload proof",
            description2: "Receive the book, read it, and post Amazon review. Then upload receipt of purchase and photo.",

            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files and review.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the book price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Purchase the Paperback directly on Amazon. Reimbursement: +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? book.selectedCurrentUserAssign?.assignment_price_amz ?? 'the book’s retail price'} (excluding delivery)`,
            full_subtitle1: "Verified Purchase and Amazon review required. Proof of purchase is mandatory.",
            full_description1: (
                <p>
                    Please purchase the <b>exact paperback ASIN</b> listed for this assignment using your Amazon
                    account.
                    Do <b>not</b> buy used copies or from third-party sellers. Once delivered, leave your honest
                    review
                    — it must show the <b>Verified Purchase</b> label. Reimbursement covers the book’s retail
                    price
                    <b> excluding delivery costs</b>. Use the button below to open the Amazon page and complete
                    your purchase.
                </p>
            ),

            full_title2: "Post review and upload your purchase proof and book photo.",
            full_subtitle2: "Submit your review and purchase evidence for verification.",
            full_description2: (
                <p>
                    After reading the book, <b>post your honest Amazon review</b> using the same account you made the purchase with.
                    Then upload a <b>screenshot of your Amazon order receipt</b> showing the order ID, title (or ASIN),
                    date, price, and your account name — <b>plus a photo of the physical book you received</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),


            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit this assignment after uploading your proof of purchase and posting your Amazon review.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>book’s retail price
                    (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the Paperback Verified Purchase
                    assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Paperback on Amazon",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title2: "Post review & Upload proof",
            description2: "Receive the book, read it, and post Amazon review. Then upload receipt of purchase and photo.",

            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files and review.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the book price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Post review and upload your purchase proof and book photo.",
            full_subtitle2: "Submit your review and purchase evidence for verification.",
            full_description2: (
                <p>
                    After the book is delivered, read it carefully and share your honest thoughts in a
                    well-written review. Keep it original, respectful, and accurate — AI-generated, plagiarized, or generic reviews
                    are not accepted. Make sure you post from the same Amazon account you used to purchase the book so the review will
                    shows with the <b> Verified Purchase</b> label. Then upload a <b>screenshot of your Amazon order receipt</b> showing the order ID, title (or ASIN),
                    date, price, and your account name — <b>plus a photo of the physical book you received</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit this assignment after uploading your proof of purchase and posting your Amazon review.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>book’s retail price
                    (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the Paperback Verified Purchase
                    assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Paperback on Amazon",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post review & Upload proof",
            description2: "Your review is posted. And Your proof has been successfully uploaded to the system.",

            icon3: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title3: "Turn in this assignment",
            description3: "Submit this assignment after uploading your proof of purchase and posting your review.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the book price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit this assignment after uploading your proof of purchase and posting your Amazon review.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Verification in progress",
            full_subtitle4: "We’ll review your files and confirm order details.",
            full_description4: (
                <p>
                    Our team will check your review on Amazon and validate the purchase details from your
                    uploaded files.
                    If anything is missing or unclear, we’ll ask you to re-upload or provide additional
                    information.
                    Once approved, we’ll credit your <b>Virt</b> and reimburse the <b>book’s retail price
                    (excluding delivery)</b>.
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Paperback on Amazon",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post review & Upload proof",
            description2: "Your review is posted. And Your proof has been successfully uploaded to the system.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title4: "Reimbursement & Virt credit",
            description4: "We received your submission. We’ll verify it and credit upon approval. You’ll be notified soon.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification in progress",
            full_subtitle4: "We’re checking your review and proof of purchase.",
            full_description4: (
                <p>
                    Our team is validating your Amazon review and confirming that the <b>Verified
                    Purchase</b> label is present.
                    We’re also reviewing the uploaded screenshot/photo of your Amazon order to ensure it
                    includes the required details:
                    Order ID, book title or ASIN, order date, book price, and your Amazon account name.{" "}
                    Once verified, your <b>Virt</b> and reimbursement (excluding delivery costs) will be
                    credited.
                    If anything is missing, we’ll contact you for clarification or re-upload.
                </p>
            ),
            verified_purchase: "Verified Purchase",
            review_name: user?.user?.amz_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",

        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Paperback on Amazon",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post review & Upload proof",
            description2: "Your review is posted. And Your proof has been successfully uploaded to the system.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Assignment confirmed!",
            description4: "Congratulations! Your review and purchase have been verified. Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <p>
                    This assignment is now closed. You have received your <b>Virt</b> and reimbursement of the
                    <b> book’s retail price (excluding delivery)</b>. Please note that if verification later reveals
                    discrepancies in your submitted files, adjustments to your balance may still be required.
                    Thank you for completing the assignment!
                </p>
            ),

            verified_purchase: "Verified Purchase",
            review_name: user?.user?.amz_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
    },
});
